// extracted by mini-css-extract-plugin
export default {"container":"ModalFooter--container--767dea","alignEnd":"ModalFooter--alignEnd--2763c7"};